import React, {Fragment, useEffect, useState} from 'react';

import {FormatDisplay, ToastService, useDataTableBasic, useDialogCrup} from '@iamsoftware/react-hooks';

import {AgreementService as Service} from './AgreementService';

const optionCheck = [
  {value: 'Y', label: 'Tích chọn'},
  {value: 'N', label: 'Không tích'}
]


export const Crup = ({agreementId, display, setDisplay, setDisplayDialog,  reloadLazyData}) => {

  const header = 'Hợp đồng';
  const dataKey = 'agreementId';


  const [formFields, setFormFields] = useState([]);
  useEffect(() => {
    if (display) {
      const formattedFields = display?.dbFormFields.map(formatFieldValue) || [];
      setFormFields(formattedFields)
      if (agreementId) {
        update(display)
      } else {
        create()
      }
    }
  }, [display]); // eslint-disable-line react-hooks/exhaustive-deps

  const formatFieldValue = fieldData => {
    // Create a copy to avoid mutating original data
    const formattedField = { ...fieldData };
    
    switch (formattedField.fieldTypeEnumId) {
      case 'DBFFAT_date-long':
      case 'DBFFAT_date-short':
        if (formattedField.value) {
          
          
          // Đảm bảo format YYYY-MM-DD cho input date
          const date = new Date(parseInt(formattedField.value));
          if (!isNaN(date.getTime())) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const formattedValue = `${year}-${month}-${day}`;
            
            formattedField.value = formattedValue;
          } else {
            
            formattedField.value = '';
          }
        } else {
          formattedField.value = '';
        }
        break;
      default:
    }
    return formattedField;
  }


  const onEditorChange = (rowData, column, newValue) => {
    setFormFields(prevItems => prevItems.map(prevItem => {
      if (prevItem.fieldName === rowData.fieldName) {
        return {
          ...prevItem,
          [column.field]: newValue
        }
      }
      return prevItem;
    }));
  }

  const {render: renderDataTableItem} = useDataTableBasic({
    tableHeader: `Danh sách trường thông tin`,
    dataKey: 'fieldName',
    indexColumnWidth: 45,
    columns: [
      {field: 'title', header: 'Tên trường', minWidth: 200, sortable: false},
      {field: 'tooltip', header: 'Mô tả', minWidth: 200, sortable: false},
      {field: 'isRequired', header: 'Bắt buộc', width: 120, dataType: 'checkbox', sortable: false},
      {field: 'fieldTypeEnum', header: 'Kiểu dữ liệu', width: 280, sortable: false}
    ],
    items: formFields
  });


  const {render: renderDialog, create, update} = useDialogCrup({
    header,
    dataKey,
    fields: [
      {type: 'custom', body: renderDataTableItem(), className: 'md:col-12'}
    ],
    createItem: item => {
      const payload = inject(display);
      return validate().then(() => Service.create(payload).then(() => {
        setDisplay(null);
        setDisplayDialog(null);
        reloadLazyData();
      }));
    },
    updateItem: item => {
      const payload = inject(display);
      return validate().then(() => Service.update(agreementId, payload).then(() => {
        setDisplay(null);
        setDisplayDialog(null);
        reloadLazyData();
      }));
    },
    reloadLazyData,
    originalDialogProps: {
      maximized: true
    } as any,
    useSaveSplitButton: false,
  });

  const validate = () => {
    return new Promise<void>((resolve, reject) => {
      if (formFields?.length) {
        if (formFields.filter(it => it.isRequired === 'Y' && !it.value).length) {
          reject();
          ToastService.error(`Các trường [${formFields.filter(it => it.isRequired === 'Y' && !it.value).map(it => it.title).join(', ')}] chưa có dữ liệu.`);
        } else {
          resolve();
        }
      } else {
        reject();
        ToastService.error('Chưa có Danh sách trường thông tin.');
      }
    });
  }

  const inject = item => {
    // IMPORTANT: do not mutate `formFields` state objects when preparing payload
    const payloadFields = formFields.map(originalField => {
      const fieldData = { ...originalField };
      switch (fieldData.fieldTypeEnumId) {
        case 'DBFFAT_date-short':
        case 'DBFFAT_date-long':
          if (fieldData.value) {
            // Convert UI value (yyyy-MM-dd) to timestamp (ms). If already a number-like string, keep as ms.
            const numeric = parseInt(fieldData.value as any);
            if (!Number.isNaN(numeric) && `${numeric}`.length >= 10) {
              fieldData.value = `${numeric}`;
            } else {
              const dt = new Date(fieldData.value);
              fieldData.value = isNaN(dt.getTime()) ? '' : `${dt.getTime()}`;
            }
          }
          break;
        default:
      }
      return fieldData;
    });
    return { ...item, dbFormFields: payloadFields };
  }

  return <div>
    {renderDialog()}
  </div>
}